<audio id="player" controls>
  @for (audioSource of audioSources; track audioSourceTracker($index)) {
    <source
      [src]="audioSource.src"
      [type]="audioSource.type"
      />
  }
</audio>
